import { useEffect, useState } from "react";
import { Megaphone } from "lucide-react";
import { api } from "../../lib/api";
import { BrutalCard, Badge, SectionTitle } from "../../components/common/Brutal";

export default function CamperAnnouncements() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/announcements").then(({ data }) => setItems(data));
  }, []);

  return (
    <div className="space-y-6">
      <SectionTitle kicker="Announcements" title="Stay in the loop" />
      <div className="space-y-4">
        {items.map((a) => (
          <BrutalCard
            key={a.id}
            className="p-5"
            data-testid={`announcement-${a.id}`}
          >
            <div className="flex items-center gap-2 mb-2">
              <div className="bg-[#FFB400] kf-border h-8 w-8 grid place-items-center">
                <Megaphone className="h-4 w-4" strokeWidth={2.75} />
              </div>
              <Badge
                color={
                  a.priority === "urgent"
                    ? "red"
                    : a.priority === "warning"
                      ? "amber"
                      : "yellow"
                }
              >
                {a.priority}
              </Badge>
              <span className="text-[10px] uppercase tracking-widest text-[#6B4E9E] ml-auto">
                {new Date(a.created_at).toLocaleDateString()}
              </span>
            </div>
            <h3 className="display text-2xl">{a.title}</h3>
            <p className="text-[#6B4E9E] mt-1">{a.message}</p>
          </BrutalCard>
        ))}
        {items.length === 0 && (
          <BrutalCard className="p-8 text-center text-[#6B4E9E]">
            No announcements yet.
          </BrutalCard>
        )}
      </div>
    </div>
  );
}
